/** Minimum overlap duration; touching endpoints (0 ms) are ignored. */
export const OVERLAP_MINIMUM_MS = 60 * 1000

export function intervalsOverlapMoreThanOneMinute(startA, endA, startB, endB) {
  const overlapMs = Math.min(new Date(endA), new Date(endB))
    - Math.max(new Date(startA), new Date(startB))
  return overlapMs >= OVERLAP_MINIMUM_MS
}

/** Sorted entries: prev ends at or after current starts by at least one minute. */
export function consecutiveEntriesOverlapMoreThanOneMinute(prevEnd, currentStart) {
  const overlapMs = new Date(prevEnd) - new Date(currentStart)
  return overlapMs >= OVERLAP_MINIMUM_MS
}
